import { ThemeSchema, type Theme } from '../../../../packages/shared/src/theme';

const tokenNames = [
  'bg', 'surface', 'sunken', 'ink', 'inkMuted', 'line', 'accent',
  'accentInk', 'ok', 'warn', 'danger', 'info'
] as const;

function channels(hex: string): string {
  return hex.slice(1).match(/.{2}/g)?.map((part) => parseInt(part, 16)).join(' ') ?? '';
}

export function applyTheme(input: unknown, root: HTMLElement = document.documentElement): Theme {
  const theme = ThemeSchema.parse(input);
  // Use the authored accentInk. parseTheme already rejects a theme whose accentInk
  // falls below 4.5:1 on the accent, so auto-selecting here (style.md §2) would only
  // ever override a value that has already passed the guard.
  const tokens = theme.tokens;

  tokenNames.forEach((key) => {
    const cssName = key.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
    root.style.setProperty(`--${cssName}`, channels(tokens[key]));
  });
  root.style.setProperty('--radius', `${theme.tokens.radius}px`);
  root.style.setProperty('--border', `${theme.tokens.border}px`);
  root.dataset.theme = theme.id;
  root.dataset.density = theme.density;
  root.dataset.scheme = theme.scheme;
  return theme;
}